// extracted by mini-css-extract-plugin
export var chip = "_2o-9";
export var chipLabel = "_2o-a";
export var close = "_2o-7";
export var closeIcon = "_2o-8";
export var error = "_2o-6";
export var infoTooltip = "_2o-2";
export var innerContainer = "_2o-1";
export var input = "_2o-b";
export var medium = "_2o-5";
export var outerContainer = "_2o-0";
export var small = "_2o-4";
export var xSmall = "_2o-3";